import { Outlet } from 'react-router-dom';

const MainLayout = ({ children }) => {
  return children || <Outlet />
};

export default MainLayout;